import { useCallback, useEffect, useRef, useState } from 'react';
export const useWhopPaymentPolling = ({ apiService, checkoutSessionId, maxAttempts = 60, intervalMs = 2000, onSuccess, onMaxAttemptsReached, onError, }) => {
    const pollIntervalRef = useRef(null);
    const attemptsRef = useRef(0);
    const currentParamsRef = useRef(null);
    const [isPolling, setIsPolling] = useState(false);
    const stopPolling = useCallback(() => {
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        setIsPolling(false);
        attemptsRef.current = 0;
        currentParamsRef.current = null;
    }, []);
    const startPolling = useCallback((receiptId, orderId) => {
        stopPolling();
        attemptsRef.current = 0;
        currentParamsRef.current = { receiptId, orderId };
        setIsPolling(true);
        pollIntervalRef.current = setInterval(async () => {
            if (!currentParamsRef.current)
                return;
            try {
                attemptsRef.current++;
                console.log(`Whop payment polling attempt ${attemptsRef.current}/${maxAttempts}...`);
                const data = await apiService.fetch(`/api/v1/checkout-sessions/${checkoutSessionId}/whop-payment-status`, {
                    method: 'POST',
                    body: JSON.stringify(currentParamsRef.current),
                    headers: { 'Content-Type': 'application/json' },
                });
                if (data && (data.status === 'succeeded' || data.status === 'declined')) {
                    stopPolling();
                    onSuccess?.(data);
                }
                else if (attemptsRef.current >= maxAttempts) {
                    stopPolling();
                    onMaxAttemptsReached?.();
                }
            }
            catch (error) {
                console.warn(`Whop polling attempt ${attemptsRef.current} failed:`, error);
                if (attemptsRef.current >= maxAttempts) {
                    stopPolling();
                    onError?.(error instanceof Error ? error : new Error(String(error)));
                }
                // Otherwise keep polling through transient errors
            }
        }, intervalMs);
    }, [apiService, checkoutSessionId, maxAttempts, intervalMs, onSuccess, onMaxAttemptsReached, onError, stopPolling]);
    useEffect(() => {
        return () => {
            stopPolling();
        };
    }, [stopPolling]);
    return {
        startPolling,
        stopPolling,
        isPolling,
    };
};
